import { Reducer } from 'redux';
import { IAction } from '../types';
import { localKeyInfo } from '../config';
import LocalStore from '@/utils/store';

export interface RoomTotalState {
  total: number;
}

const LOCALKEY = localKeyInfo.roomTotal;
const localVoiceInfo = LocalStore.getValue<RoomTotalState>(LOCALKEY) || {};

export const roomTotal: RoomTotalState = {
  total: 0,
  ...localVoiceInfo
};

export const setRoomTotal: (payload: RoomTotalState) => IAction<RoomTotalState> = (payload: RoomTotalState) => ({
  type: 'setRoomTotal',
  payload
});

const roomTotalReducer: Reducer<RoomTotalState, IAction<any>> = (state = roomTotal, action: IAction<any>) => {
  const { type, payload } = action;
  switch (type) {
    case 'setRoomTotal':
      LocalStore.setValue(LOCALKEY, payload);
      return {
        ...payload
      };
    default:
      return state;
  }
};

export default roomTotalReducer;
